import EndPoint from "../common/endpoints";
import { ApiAdminConfig, ApiConfig } from "./config";

export const apiLogin = async (payload) => {
  return ApiConfig(EndPoint.LOGIN, payload);
};
export const apiGetListPet = async (params) => {
  const { page = 1, size = 20, keyword = "" } = params;
  return ApiAdminConfig(
    `${EndPoint.LIST_PET}?page=${page}&size=${size}&keyword=${keyword}`,
    undefined,
    "GET"
  );
};

export const apiUpdatePet = async (params) => {
  return ApiAdminConfig(EndPoint.UPDATE_PET, params);
};

export const apiUpdateHistoryVaccine = async (params) => {
  return ApiAdminConfig(EndPoint.UPDATE_VACCINE_HISTORY, params);
};

export const apiDeletePets = async (params) => {
  return ApiAdminConfig(EndPoint.DEL_PET, params);
};

export const apiImportExcelFile = async (file) => {
  const form = new FormData();
  form.append("file", file);
  form.append("isReload", false);

  return ApiAdminConfig(EndPoint.IMPORT_FILE, form, "POST", {
    "Content-Type": "multiform/form-data",
  });
};
